import { ItemListProvider } from '@/components/itemList/ItemListProvider';
import { FileRow } from '@/components/itemList/FileRow';
import type { NormalizedItem } from '@/components/itemList/types';

interface LinkFileListProps {
  items: NormalizedItem[];
  onRefresh: () => void;
  updateIsQuerying: (querying: boolean) => void;
  onClickItem: (item: NormalizedItem) => void;
}

export function LinkFileList({ items, onRefresh, updateIsQuerying, onClickItem }: LinkFileListProps) {
  return (
    <ItemListProvider
      items={items}
      userRole="viewer"
      useCase="link"
      onRefresh={onRefresh}
      updateIsQuerying={updateIsQuerying}
    >
      <ul className="space-y-1 p-0 m-0 list-none">
        {items.map((item) => (
          <FileRow
            key={item.id}
            item={item}
            variant="minimal"
            onClickItem={onClickItem}
          />
        ))}
      </ul>
    </ItemListProvider>
  );
}
